import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { from, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AppState, RoleMgr, ShowRequest } from '../../core';
import { ScoutPath, ScoutPoint, TaskStatus } from '../../core/models';
import { ScoutTaskDoc } from '../../core/schema/scout-task-schema';
import { extractPathNumberFromPathId, ScoutTaskService } from '../../core/services';
import { ScoutPointPhotoSelected } from '../../scout/scout-point/scout-point-photo-browser/scout-point-photo-browser.component';
import { ScoutPointPhotoModal } from '../../scout/scout-point/scout-point-photo-modal/scout-point-photo-modal.component';
import { ScoutPointRefDialogComponent } from '../../scout/scout-point/scout-point-ref-dialog/scout-point-ref-dialog.component';


@Component({
  selector: 'app-path-scout-source',
  templateUrl: './path-scout-source.component.html',
  styleUrls: ['./path-scout-source.component.scss']
})
export class PathScoutSourceComponent implements OnInit {

  @Input() public pathId : string
  @Input() public buildingId : string
  @Input() public stage: string
  @Input() public bExpanded = false
  @Input() public bTabSelected = false
  @Input() public selectedPointId : string = null
  @Input() public title = "Scout Information"
  @Output() resolvedScoutPath = new EventEmitter<{ scoutTask: ScoutTaskDoc, scoutPath: ScoutPath }>();

  scoutAndPath$ : Observable<{ scoutTask: ScoutTaskDoc, scoutPath: ScoutPath }>
  warningMsg : string = null

  constructor(
    protected appState: AppState,
    protected scoutService: ScoutTaskService,
    protected roleMgr: RoleMgr,
    protected bsModalService: BsModalService
  ){
  }

  scoutAndPathInitialized = false

  ngOnInit(): void {
    const pathNumber = extractPathNumberFromPathId(this.pathId);
    console.log( 'searching for scout path #' + pathNumber)
    let pathQuery = this.scoutService.rxCollection.find().where('buildingId').eq(this.buildingId)
    pathQuery.where('scoutPaths').elemMatch({pathNumber: pathNumber})
    this.scoutAndPath$ = from(pathQuery.$).pipe(
      map( scoutTasks => {
        this.warningMsg = null
        let rtnVal : { scoutTask: ScoutTaskDoc, scoutPath: ScoutPath } = null
        const stageScoutTasks = scoutTasks.filter(scout=>!this.stage || scout.stage==this.stage )
        if ( stageScoutTasks.length > 0 ) {
          scoutTasks = stageScoutTasks
        }
        for ( const scoutTask of scoutTasks ) {
          let scoutPath = scoutTask?.scoutPaths.find(sp=>sp.pathNumber==pathNumber)
          if ( scoutPath ) {
            if ( rtnVal ) {
              throw new Error(`Multiple scouts found for building='${this.buildingId}', path='${pathNumber}'`)
            } else {
              this.scoutService.updateScoutPathContext(scoutPath,[])
              rtnVal = { scoutTask, scoutPath }
            }
          }
        }
        if ( !rtnVal?.scoutPath ) {
          this.warningMsg = `No scout path found for building='${this.buildingId}', stage='${this.stage||""}', path='${pathNumber}'`
        }
        this.scoutAndPathInitialized = true
        return rtnVal
      }),
      tap((result) => {
        if (result) {
          this.resolvedScoutPath.emit(result);
        }
      }),
      catchError(error=>{
        this.scoutAndPathInitialized = true
        console.warn(error)
        this.warningMsg = error?.message
        return of( null )
      })
    )
  }

  onShowBuilding(buildingId: string) {
    this.appState.showView.next( new ShowRequest('tab','building', buildingId) )
  }


  onShowScoutPath(scoutTaskDoc: ScoutTaskDoc, scoutPath: ScoutPath) {
    this.appState.showView.next( new ShowRequest('tab','scout path', scoutPath.id, scoutTaskDoc) )
  }


  /*
  onReportDoc( scoutTaskDoc: ScoutTaskDoc, scoutPath: ScoutPath, evt : MouseEvent ) {
    this.appState.showView.next( new ShowRequest('tab', 'scout report', scoutPath.id, scoutTaskDoc) )
  }


  onReportData( scoutTaskDoc: ScoutTaskDoc, scoutPath: ScoutPath, evt : MouseEvent ) {
    const strContext = JSON.stringify({ pathIds: [ scoutPath.id ] })
    this.appState.showView.next( new ShowRequest('tab', 'scout data report', strContext, scoutTaskDoc) )
  }
  */

  onShowScoutPointPhoto = ( photoSelectedEvt : ScoutPointPhotoSelected ) => {
    let uiLocked = TaskStatus.uiLockHandler(photoSelectedEvt.path?.statusId, this.roleMgr.canEditUsers)
    const context : ModalOptions = {
      initialState: {
        locked: uiLocked,
        ...photoSelectedEvt
      },
      class: 'photo-modal',
      id: ScoutPointPhotoModal.ModalId,
      animated: true,
      ignoreBackdropClick: true
    }
    const modalRef = this.bsModalService.show(ScoutPointPhotoModal, context );
  }


  onShowScoutPoint = ( scoutTaskDoc: ScoutTaskDoc, scoutPath: ScoutPath, scoutPoint: ScoutPoint ) => {
    let uiLocked = TaskStatus.uiLockHandler(scoutPath.statusId, this.roleMgr.canEditUsers)
    const context : ModalOptions = {
      initialState: {
        scoutPointId: scoutPoint.id,
        scoutPathId: scoutPath.id,
        scoutTaskDoc,
        allowEditMode: true,
        locked: uiLocked
      },
      class: 'full-screen-modal',
      id: ScoutPointRefDialogComponent.ModalId,
      animated: true,
      ignoreBackdropClick: true
    }
    const modalRef = this.bsModalService.show(ScoutPointRefDialogComponent, context );
  }
 }
